export enum CoinSponsorStatus {
  All = 'all',
  Approved = 'approved',
  Disapproved = 'disapproved',
  Incomplete = 'incomplete',
  Submitted = 'submitted',
}
